export default {
    'trivia-quiz': {
        top: {
            main: require('../../images/png/landing/main/tq.png'),
            icon: require('../../images/png/landing/icon/tq.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/tq_1.png'),
            require('../../images/png/landing/icon/tq_2.png'),
            require('../../images/png/landing/icon/tq_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_tq.png'),
        comingSoonPreview: null,
    },
    'personality-quiz': {
        top: {
            main: require('../../images/png/landing/main/pq.png'),
            icon: require('../../images/png/landing/icon/pq.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/pq_1.png'),
            require('../../images/png/landing/icon/pq_2.png'),
            require('../../images/png/landing/icon/pq_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_pq.png'),
        comingSoonPreview: null,
    },
    quotes: {
        top: {
            main: require('../../images/png/landing/main/qt.png'),
            icon: require('../../images/png/landing/icon/qt.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/qt_1.png'),
            require('../../images/png/landing/icon/qt_2.png'),
            require('../../images/png/landing/icon/qt_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_qt.png'),
        comingSoonPreview: null,
    },
    photostory: {
        top: {
            main: require('../../images/png/landing/main/ps.png'),
            icon: require('../../images/png/landing/icon/ps.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/ps_1.png'),
            require('../../images/png/landing/icon/ps_2.png'),
            require('../../images/png/landing/icon/ps_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_ps.png'),
        comingSoonPreview: null,
    },
    'memory-game': {
        top: {
            main: require('../../images/png/landing/main/mg.png'),
            icon: require('../../images/png/landing/icon/mg.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/mg_1.png'),
            require('../../images/png/landing/icon/mg_2.png'),
            require('../../images/png/landing/icon/mg_3.png'),
        ],
        chooseSection: {
            forTeacherLeft: require('../../images/png/landing/memoryForTeachers/memory-literature.png'),
            forTeacherRight: require('../../images/png/landing/memoryForTeachers/memory-math.png'),
            forBusinessLeft: require('../../images/png/landing/memoryForBusiness/top-coffee.png'),
            forBusinessRight: require('../../images/png/landing/memoryForBusiness/top-watches.png'),
        },
        capability: require('../../images/png/landing/capability/editor_mg.png'),
        comingSoonPreview: null,
    },
    'rank-battle': {
        top: {
            main: require('../../images/png/landing/main/rb.png'),
            icon: require('../../images/png/landing/icon/rb.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/rb_1.png'),
            require('../../images/png/landing/icon/rb_2.png'),
            require('../../images/png/landing/icon/rb_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_rb.png'),
        comingSoonPreview: null,
    },
    'before-after': {
        top: {
            main: require('../../images/png/landing/main/ba.png'),
            icon: require('../../images/png/landing/icon/ba.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/ba_1.png'),
            require('../../images/png/landing/icon/ba_2.png'),
            require('../../images/png/landing/icon/ba_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_ba.png'),
        comingSoonPreview: null,
    },
    timeline: {
        top: {
            main: require('../../images/png/landing/main/tl.png'),
            icon: require('../../images/png/landing/icon/tl.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/tl_1.png'),
            require('../../images/png/landing/icon/tl_2.png'),
            require('../../images/png/landing/icon/tl_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_tl.png'),
        comingSoonPreview: null,
    },
    cookies: {
        top: {
            main: require('../../images/png/landing/main/fc.png'),
            icon: require('../../images/png/landing/icon/fc.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/fc_1.png'),
            require('../../images/png/landing/icon/fc_2.png'),
            require('../../images/png/landing/icon/fc_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_fc.png'),
        comingSoonPreview: null,
    },
    horoscope: {
        top: {
            main: require('../../images/png/landing/main/hs.png'),
            icon: require('../../images/png/landing/icon/hs.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/hs_1.png'),
            require('../../images/png/landing/icon/hs_2.png'),
            require('../../images/png/landing/icon/hs_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_hs.png'),
        comingSoonPreview: null,
    },
    'interactive-image': {
        top: {
            main: require('../../images/png/landing/main/ii.png'),
            icon: require('../../images/png/landing/icon/ii.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/ii_1.png'),
            require('../../images/png/landing/icon/ii_2.png'),
            require('../../images/png/landing/icon/ii_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_ii.png'),
        comingSoonPreview: null,
    },
    'hidden-objects': {
        top: {
            main: require('../../images/png/landing/main/ho.png'),
            icon: require('../../images/png/landing/icon/ho.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/ho_1.png'),
            require('../../images/png/landing/icon/ho_2.png'),
            require('../../images/png/landing/icon/ho_3.png'),
        ],
        capability: require('../../images/png/landing/capability/editor_ho.png'),
        comingSoonPreview: null,
    },
    'instant-pages': {
        top: {
            main: require('../../images/png/landing/main/ip.png'),
            icon: require('../../images/png/landing/icon/ip.png'),
        },
        advantages: [],
        capability: null,
        additional: {
            editor: require('../../images/png/landing/instantPages/editor.png'),
            addText: require('../../images/png/landing/instantPages/icon/addText.svg'),
            addImage: require('../../images/png/landing/instantPages/icon/addImage.svg'),
            addFlip: require('../../images/png/landing/instantPages/icon/addFlip.svg'),
            embedProject: require('../../images/png/landing/instantPages/icon/embedProject.svg'),
            up: require('../../images/png/landing/instantPages/icon/up.svg'),
            copy: require('../../images/png/landing/instantPages/icon/copy.svg'),
            delete: require('../../images/png/landing/instantPages/icon/delete.svg'),
            cursor: require('../../images/png/landing/instantPages/icon/cursor.svg'),
            add: require('../../images/png/landing/instantPages/icon/add.svg'),
            image1: require('../../images/png/landing/instantPages/peru.png'),
            image2: require('../../images/png/landing/instantPages/peruVideo.png'),
            arrow1: require('../../images/png/landing/instantPages/icon/arrow1.svg'),
            arrow2: require('../../images/png/landing/instantPages/icon/arrow2.svg'),
            arrow3: require('../../images/png/landing/instantPages/icon/arrow3.svg'),
            arrow3m: require('../../images/png/landing/instantPages/icon/arrow3m.svg'),
            arrow4: require('../../images/png/landing/instantPages/icon/arrow4.svg'),
            arrow4m: require('../../images/png/landing/instantPages/icon/arrow4m.svg'),
        },
        comingSoonPreview: null,
    },
    'memory-games-for-teachers': {
        top: require('../../images/png/landing/memoryForTeachers/topImage.png'),
        advantages: [
            require('../../images/png/landing/icon/mgft_1.png'),
            require('../../images/png/landing/icon/mgft_2.png'),
            require('../../images/png/landing/icon/mgft_3.png'),
        ],
        cards: [
            require('../../images/png/landing/memoryForTeachers/card1.png'),
            require('../../images/png/landing/memoryForTeachers/card2.png'),
            require('../../images/png/landing/memoryForTeachers/card3.png'),
            require('../../images/png/landing/memoryForTeachers/card4.png'),
            require('../../images/png/landing/memoryForTeachers/card5.png'),
        ],
    },
    'memory-games-for-business': {
        top: {
            coffee: require('../../images/png/landing/memoryForBusiness/top-coffee.png'),
            watches: require('../../images/png/landing/memoryForBusiness/top-watches.png'),
        },
        ellipse: {
            left: require('../../images/png/landing/memoryForBusiness/ellipse-left.png'),
            right: require('../../images/png/landing/memoryForBusiness/ellipse-right.png'),
        },
        advantages: [
            require('../../images/png/landing/icon/mgfb_1.png'),
            require('../../images/png/landing/icon/mgfb_2.png'),
            require('../../images/png/landing/icon/mgfb_3.png'),
        ],
        cardsAdvantages: [
            require('../../images/png/landing/memoryForBusiness/adv1.png'),
            require('../../images/png/landing/memoryForBusiness/adv2.png'),
            require('../../images/png/landing/memoryForBusiness/adv3.png'),
        ],
        cards: [
            require('../../images/png/landing/memoryForBusiness/card1.png'),
            require('../../images/png/landing/memoryForBusiness/card2.png'),
            require('../../images/png/landing/memoryForBusiness/card3.png'),
            require('../../images/png/landing/memoryForBusiness/card4.png'),
            require('../../images/png/landing/memoryForBusiness/card5.png'),
        ],
        testimonial: require('../../images/png/landing/memoryForBusiness/museum.png'),
    },
}
